import { Analytics } from 'packages';

export const trackSearchCategoryChanges = evt => {
    const selectBox = evt.target;
    const selectedOption =
        selectBox &&
        selectBox.selectedOptions &&
        selectBox.selectedOptions.length > 0 &&
        selectBox.selectedOptions[0];
    if (!selectedOption) {
        return;
    }
    const selectedValue = selectedOption.value;
    const selectedText = selectedOption.text;
    Analytics.trackEvent({
        category: 'Search box',
        action: 'SelectCategory',
        label: 'Category: ' + selectedText + ' | CategoryID: ' + selectedValue
    });
};

export const trackSearch = () => {
    Analytics.trackEvent({
        category: 'Search box',
        action: 'Navigation'
    });
};

export const trackResetButton = () => {
    Analytics.trackEvent({
        category: 'Search box',
        action: 'Navigation',
        label: 'Reset button click'
    });
};
